import { Component, OnInit, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BuildingFloor } from '../common-theme/models/index';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';

@Component({
  selector: 'app-floors',
  templateUrl: './floors.component.html'
})
export class FloorsComponent extends SeoAwareBaseComponent implements OnInit {
  buildingFloor: BuildingFloor;

  constructor(
    injector: Injector,
    private route: ActivatedRoute
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.buildingFloor = this.route.snapshot.data.building_floor;
  }
}



// WEBPACK FOOTER //
// ./src/app/floors/floors.component.ts